import React from "react";
import { Route } from "react-router-dom";

const PublicRoute = ({ component: Component, ...rest }) => {
  const renderComponent = (props) => {
    return <Component {...rest} {...props} />;
  };
  return <Route render={renderComponent} {...rest} />;
};

export default PublicRoute;
